import { rest } from 'msw';
import { getEnv } from 'util/getEnv';
import {
  createCustomerTagData,
  getCustomerTags,
} from './fixtures/customer-tag.fixture';
import {
  getAccountChangeLogs,
  getCustomerData,
  getCustomersData,
  getResetPasswordLink,
} from './fixtures/customers.fixtures';
import { CustomerStatus } from 'components/customer/customer.constants';

export const listCustomerTagsMock = fn =>
  rest.get(
    `${getEnv('REACT_APP_ADMIN_API_URL')}/incentivio-user-domain/customer-tags`,
    fn,
  );

export const getCustomerTagMock = fn =>
  rest.get(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-user-domain/customer-tags/:customerTagId`,
    fn,
  );

export const createCustomerTagMock = fn =>
  rest.post(
    `${getEnv('REACT_APP_ADMIN_API_URL')}/incentivio-user-domain/customer-tags`,
    fn,
  );

export const updateCustomerTagMock = fn =>
  rest.put(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-user-domain/customer-tags/:customerTagId`,
    fn,
  );

export const deleteCustomerTagMock = fn =>
  rest.delete(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-user-domain/customer-tags/:customerTagId`,
    fn,
  );

export const getCustomerMock = fn =>
  rest.get(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-user-domain/clients/:clientId/useraccounts/:customerId`,
    fn,
  );

export const updateCustomerMock = fn =>
  rest.put(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-user-domain/clients/:clientId/useraccounts/:userId/by-admin`,
    fn,
  );

export const verifyEmailMock = fn =>
  rest.post(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-user-domain/clients/:clientId/useraccounts/:userId/verify`,
    fn,
  );

export const addRemoveCustomerTagMock = fn =>
  rest.patch(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-user-domain/clients/:clientId/useraccounts/:userId`,
    fn,
  );

export const getListUsersMock = fn =>
  rest.get(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-user-domain/clients/:clientId/users/filter`,
    fn,
  );

export const getIsClientConfigReachEnabled = fn =>
  rest.get(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-user-domain/clients/:clientId/clientconfig/reach`,
    fn,
  );

export const deleteCustomerMock = fn =>
  rest.delete(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-user-domain/clients/:clientId/useraccounts/:userId`,
    fn,
  );

export const getResetPasswordLinkMock = fn =>
  rest.post(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-user-domain/users/:emailUser/requestpwreseturl`,
    fn,
  );

export const blockUserMock = fn =>
  rest.post(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-user-domain/useraccounts/:userId/block`,
    fn,
  );

export const unblockUserMock = fn =>
  rest.post(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-user-domain/useraccounts/:userId/unblock`,
    fn,
  );

export const getAccountChangeLogsMock = fn =>
  rest.get(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-user-domain/useraccounts/:userId/account-change-logs`,
    fn,
  );

export const handlers = () => [
  listCustomerTagsMock((_req, res, ctx) => {
    return res(ctx.json(getCustomerTags));
  }),

  getCustomerTagMock((_req, res, ctx) => {
    return res(ctx.json(getCustomerTags.tagAndRuleDTOS[0]));
  }),

  createCustomerTagMock((_req, res, ctx) => {
    return res(ctx.json(createCustomerTagData));
  }),

  updateCustomerTagMock((_req, res, ctx) => {
    return res(ctx.status(200));
  }),

  deleteCustomerTagMock((_req, res, ctx) => {
    return res(ctx.status(200));
  }),

  getCustomerMock((req, res, ctx) => {
    const customer = getCustomersData.users.find(
      user => user.userId === req.params.customerId,
    );

    if (!!customer)
      return res(
        ctx.json({
          ...customer,
          mergedPrimaryUserAccountId: null,
          household: null,
          address: null,
          status: CustomerStatus.VERIFIED,
          accountAliasId: 'aetqatest6754',
          userProfileImageUrl:
            'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/profile/5c77dc94-a2e3-4929-a237-e1f6fd612724.png',
        }),
      );

    return res(ctx.json(getCustomerData));
  }),

  updateCustomerMock((_req, res, ctx) => {
    return res(ctx.status(200));
  }),

  verifyEmailMock((_req, res, ctx) => {
    return res(ctx.status(200));
  }),

  addRemoveCustomerTagMock((_req, res, ctx) => {
    return res(ctx.status(200));
  }),

  getListUsersMock((_req, res, ctx) => {
    return res(ctx.json(getCustomersData));
  }),

  getIsClientConfigReachEnabled((_req, res, ctx) => {
    return res(ctx.json(true));
  }),

  deleteCustomerMock((_req, res, ctx) => {
    return res(ctx.status(200));
  }),

  getResetPasswordLinkMock((_req, res, ctx) => {
    return res(ctx.text(getResetPasswordLink));
  }),

  blockUserMock((_req, res, ctx) => {
    return res(ctx.json({ userId: '02e4d2f5-2f4e-44cd-833f-d4c7e2e408ab' }));
  }),

  unblockUserMock((_req, res, ctx) => {
    return res(ctx.json({ userId: '02e4d2f5-2f4e-44cd-833f-d4c7e2e408ab' }));
  }),

  getAccountChangeLogsMock((_req, res, ctx) => {
    return res(ctx.json(getAccountChangeLogs));
  }),
];
